import {
    IRetriableQuestion,
    QuestionElementInteractions,
    QuestionnaireElementInteraction,
} from '../../../../../incase-domain/proptypes/runfile';
import {IElementQuestion} from '../../../../../incase-domain/elements/question/question';
import {IElementPhotoAnswerQuestion} from '../../../../../incase-domain/elements/question/photoAnswerQuestion';
import {IPresentation} from '../../../../../incase-domain/presentation';
import {isQuestionRetriable} from '../../../../../util/util';
import {IElementBase} from '../../../../../incase-domain/elements/base/elementBase';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';

export function handleSelectAnswer<T extends IElementQuestionnaire & IElementBase, K extends number | string>(
    elementInteractions: QuestionElementInteractions,
    element: T,
    indexOrId: K,
    propsMarkedAnswers: K[],
    savePresentationRunFile: (elementRunFile: QuestionnaireElementInteraction, newPoints?: number) => void,
    presentation: IPresentation | undefined
): void {
    const {answered} = elementInteractions;

    const isSingleCorrectMultiselect = element.type === ELEMENT.MULTI_SELECT && element.singleCorrect;

    if (answered) {
        return;
    }

    let updatedMarkedAnswers;
    if (element.singleCorrect) {
        updatedMarkedAnswers = [indexOrId];
    } else if (propsMarkedAnswers.includes(indexOrId)) {
        updatedMarkedAnswers = propsMarkedAnswers.filter((markedAnswer) => markedAnswer !== indexOrId);
    } else {
        updatedMarkedAnswers = [...propsMarkedAnswers, indexOrId];
    }

    if (isSingleCorrectMultiselect) {
        const interactionForUpdate =
            typeof indexOrId === 'number'
                ? {markedAnswers: updatedMarkedAnswers, answered: false}
                : {markedAnswersIds: updatedMarkedAnswers, answered: false};
        savePresentationRunFile(interactionForUpdate);
        return;
    }

    const interactionForUpdate =
        typeof indexOrId === 'number'
            ? {markedAnswers: updatedMarkedAnswers, answered: false}
            : {markedAnswersIds: updatedMarkedAnswers, answered: false};

    if (!isQuestionRetriable(element, presentation)) {
        savePresentationRunFile(interactionForUpdate);
    }

    if (isQuestionRetriable(element, presentation)) {
        savePresentationRunFile({
            ...interactionForUpdate,
            retriedAnswers: elementInteractions.retriedAnswers || [],
        } as unknown as QuestionnaireElementInteraction);
    }
}

export function handleSelectAnswers<T extends IElementQuestionnaire & IElementBase>(
    elementInteractions: IRetriableQuestion,
    element: T,
    answers: unknown[],
    savePresentationRunFile: (elementRunFile: Record<string, unknown>, newPoints?: number) => void,
    presentation: IPresentation | undefined
): void {
    const {answered} = elementInteractions;

    if (answered) {
        return;
    }

    if (!isQuestionRetriable(element, presentation)) {
        savePresentationRunFile({
            markedAnswers: answers,
        });
    }

    if (isQuestionRetriable(element, presentation)) {
        savePresentationRunFile({
            markedAnswers: answers,
            retriedAnswers: elementInteractions.retriedAnswers || [],
        });
    }
}

export function getCorrectIncorrectAnswerTypeForTryButton(
    element: IElementQuestion | IElementPhotoAnswerQuestion,
    index: number,
    propsClickedAnswers: number[],
    elementInteractions: QuestionElementInteractions,
    propsMarkedAnswers: number[]
): string {
    const answer = element.answers[index];
    const clicked = propsClickedAnswers.includes(index) || (elementInteractions.answered && answer.type === 'correct');
    const markedClass = propsMarkedAnswers.includes(index) ? 'is-marked' : '';

    const {type} = answer;
    let correctClass = 'is-debatable';
    if (type === 'correct') {
        correctClass = 'is-correct';
    } else if (type === 'incorrect') {
        correctClass = 'is-incorrect';
    }

    if (elementInteractions.answered && clicked) {
        return correctClass;
    }

    return markedClass;
}
